
    import {defineComponent, reactive, toRefs, onMounted, watch, nextTick} from 'vue'
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.css';


    interface State {
        dataListV: object[];
        defectSwiper: object;
        defectSlideIndex: number;
    }

    export default defineComponent({
        name: "photoDefect",
        props: {
            dataList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            initialSlide: {
                type: Number,
                default: 0,
            }
        },
        setup(props: any, ctx: any) {
            let state: State = reactive({
                dataListV: [],
                defectSwiper: {},
                defectSlideIndex: 0,
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path ? path.replace(reg, "https://$2$3$4$5$6") : path;
                return path
            }
            // const {initialSlide} = toRefs(props);
            let {dataList, initialSlide} = toRefs(props);
            // dataList = dataList.value;
            onMounted(() => {
                nextTick(()=>{
                    state.defectSlideIndex = initialSlide.value;
                    state.defectSwiper = new Swiper('.def_swiper-container', {
                        direction: 'horizontal',
                        loop: true,
                        zoom: false,
                        preloadImages: false,
                        observer: true,// 修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,// 修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                state.defectSlideIndex = this.activeIndex;
                            },
                        }
                    })
                    watch(dataList, (data: any) => {
                        state.dataListV = JSON.parse(JSON.stringify(data));
                    })
                })
            })
            
            
            return {
                state,
                urlConversion
            }
        }
    })
